<template>
  <div class="footer-box">
    <div class="content">
      <div class="flex content-space-between" id="#contact">
        <div class="title-col">
          <p class="title mb-30"><a href="/about" class="">关于我们</a></p>
          <p class="title mb-30"><a target="_blank" href="https://developer.aioukeji.net/docs/en/1-getting-started/Overview.html">开发文档</a></p>
          <p class="title mb-30"><a href="/joinus" class="">加入我们</a></p>
        </div>
        <div class="ivu-col">
          <div class="title flex am_c">
            <i class="mr-10"><img src="/static/img/mail.png" width="28"/></i>
            <div>联系我们</div></div> <div class="footer_divider ml-5 mt-10 mb-10"></div>
              <p class="info"><a href="mailto:bd@aioukeji.net">北京总部 - bd@aioukeji.net</a></p>
              <p class="info"><a href="mailto:bd@aioukeji.net">宁波分部 - nb@aioukeji.net</a></p>
              <p class="info"><a href="mailto:bd@aioukeji.net">长沙分部 - cs@aioukeji.net</a></p>
              <p class="info mb_30"><a href="mailto:support@aioukeji.net">技术支持 - support@aioukeji.net</a></p>
            </div>
          <div class="flex col am_c ivu-col">
            <p class="title">微信公众号</p>
            <div class="footer_divider mt-10 mb-10"></div>
            <img src="/static/img/wechat.png" width="110" class="wechat-qrcode">
          </div>
        </div>
      </div>
      <p class="copyright">© 2020 aioukeji.net 版权所有 <a>京ICP备 19056179号-1</a></p>
    </div>
</template>

<script>
  export default {
    name: "Foot"
  }
</script>

<style lang="less" rel="stylesheet/less">
  .footer-box {
    text-align: left;
    background: #121641;
    overflow: hidden;
    // height: 180px;
    padding-top: 60px;
    .copyright {
      text-align: center;
      margin-top: 40px;
      height: 60px;
      line-height: 60px;
      color: #ccc;
      border-top: 1px solid #1c225c;
    }
    .content {
      width: 100%;
      max-width: 1000px;
      padding: 0 20px;
      margin: 0 auto;
      a {
        color: white;
        &:hover{
          text-decoration: none;
        }
      }
      .title {
        font-size: 18px;
        color: white;
        font-weight: 400;
        
      }
      .ml-5 {
        margin-left: 5px;
      }
      .mr-10 {
        margin-right: 10px;
      }
      .mt-10 {
        margin-top: 10px;
      }
      .mb-10 {
        margin-bottom: 10px;
      }
      .mb-30 {
        margin-bottom: 30px;
      }
      .col {
        flex-direction: column;
      }
      .am_c {
        align-items: center;
      }
      .info {
        font-size: 14px;
        color: #ccc;
        margin-top: 5px;
        margin-left: 5px;
      }
      .footer_divider {
        width: 100px;
        border-top: 1px dashed #c9c9c9;
      }
      .wechat-qrcode {
        width: 110px;
        height: 110px;
        margin-top: 10px;
      }
      .flex {
        display: flex;
      }
      .content-space-between {
        justify-content: space-between;
      }
    }
  }

  @media screen and (max-width:480px) {
    .footer-box {
      height: auto;
      .content {
        width: 100%;
        .title-col {
          display: none;
        }
        .info {
          font-size: 12px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue